<script setup>

import {inject, ref} from 'vue';
import API from "@/classes/global/API";

const props = defineProps({

  modelValue: {},

})

function selectItem(item) {

  props.modelValue.skuComposites.forEach(item => {

    item.active = false;

  })

  item.active = true;

  props.modelValue.selectedSkuComposite = item.skuComposite;

  getGroupedSkuInfo(item.skuComposite);

}

async function getGroupedSkuInfo(skuComp) {

  const response = await API.getSkuHistoryGroupedSkuInfo(skuComp);

  if(response) props.modelValue.skuCompositeGridData = response
}

</script>

<template>
  <div class="cmp-sku-history-list_wrapper">
    <div v-for="item in props.modelValue.skuComposites">
      <div @click="selectItem(item)" class="cmp-sku-history-list_list-items" :title="item.skuComposite"
           :class="{'cmp-sku-history-list_active' : item.active}"><span>{{item.skuComposite}}</span>
        <i class="fa-duotone fa-circle-arrow-right cmp-sku-history-list_name-icon"></i>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

span {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.cmp-sku-history-list {

  &_wrapper {
    height: 585px;
    overflow-y: scroll;
    margin-top: 12px;
  }

  &_wrapper &_list-items {
    padding: 3px 0 3px 5px;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: -1px;
    height: 14px;
    color: #313131;
  }

  &_wrapper div:nth-child(even) {
    background-color: #fafafa;
  }

  &_wrapper &_list-items:hover {
    background-color: #eeeeee;
  }

  &_name-icon {
    visibility: hidden;
    color: #0e934b;
    margin-right: 5px;
    font-size: 14px;
  }

  &_active {
    font-weight: bold;
    background-color: #fff8e8;
  }

  &_active &_name-icon {
    visibility: visible;
  }

  @media screen and (max-width: 1679px) {

    &_wrapper {
      height: 145px;
      overflow-y: scroll;
      width: 540px;
    }
  }
}

</style>
